import { supportClient } from '@/api/axios';

export const getSupportEnabled = async (rpId: string) => {
  const { data } = await supportClient.get(`/getsupport/${rpId}`);
  return data;
};
